<template>
  <div>
    <template v-if="agreeYn == 'N'">
      <PrivacyPolicy :routeParam="$route.params"></PrivacyPolicy>
    </template>
    <template v-else>
      <div class="grey lighten-4">
        <CVProfileBanner
          ref="profile"
          :isReadonly="isReadonly"
        ></CVProfileBanner>
        <CVSection
          v-if="titles"
          :routeParam="$route.params"
          :obj="template"
          :titles="titles"
          :isReadonly="isReadonly"
        ></CVSection>
      </div>
    </template>
  </div>
</template>

<script>
import { getAuthJson } from '@/api/network';

import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import CVProfileBanner from '@/components/items/resume/CVProfileBanner.vue';
import CVSection from '@/components/items/resume/CVSection.vue';

export default {
  components: { PrivacyPolicy, CVProfileBanner, CVSection },
  data: () => ({
    template: null,
    agree: null,
    delimeter: '#',
    titles: null,
    agreeYn: 'N',
    isReadonly: false,
  }),
  beforeCreate() {
    //동의 여부 확인 후 동의가 안된 경우 동의여부 페이지로 이동하도록
    const p = { annoId: this.$route.params.annoId };
    getAuthJson('api/v1/' + this.$route.params.tenantKey + '/isagree', p)
      .then(res => {
        if (res.data && res.status === 200) {
          this.agreeYn = res.data.isAgree ? 'Y' : 'N';
          this.isReadonly = res.data.isReadonly;
          if ('Y' == this.agreeYn) this.setting();
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    setting: function() {
      const p = { annoId: this.$route.params.annoId };
      getAuthJson('api/v1/' + this.$route.params.tenantKey + '/am/cv/t', p)
        .then(res => {
          if (res && res.data) {
            this.template = res.data;
            this.titles = res.data.typeOrder.split(this.delimeter);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imageValid: function() {
      return this.$refs.profile.imageValid();
    },
  },
};
</script>

<style>
/* common */
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}
.icon-wrap {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 2px solid #637887;
  border-radius: 4px;
}
.emty-msg {
  font-size: 14px;
  color: #637887 !important;
}

[v-cloak] > * {
  display: none;
}
[v-cloak]::before {
  content: ' ';
  display: block;
  position: absolute;
  width: 80px;
  height: 80px;
  background-image: url(/images/svg/loader.svg);
  background-size: cover;
  left: 50%;
  top: 50%;
}
</style>
